import React, { useMemo } from 'react';
import Layout from '@shared/ui/organisms/layout/Layout';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import styled from "styled-components";
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { GoBackButton } from '@shared/ui/atoms/buttons/GoBackButton';
import { FlatContentCard } from '@shared/ui/atoms/FlatContentCard';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { useSelector } from "react-redux";
import { selectAllRootOffices } from "@features/desks/store/advanceHotDeskingSetup.duck";
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { OfficeContentCard } from "./components/OfficeContentCard";
import { sortOffice } from "@shared/utils/OfficeHelper";
import { selectCurrentUser } from "@shared/store/auth.duck";
import { isCompanyAdminUser, isOfficeAdminUser } from "@shared/utils/AccessControl";

export function OfficeListPageV2(props: Props) {
  const rootOffices = useSelector(selectAllRootOffices);
  const currentUser = useSelector(selectCurrentUser);
  const orderedOffice = useMemo(() => {
    return rootOffices.sort(sortOffice)
  }, [rootOffices]);

  const canAddOffices = useMemo(() => {
    if (isCompanyAdminUser(currentUser) || isOfficeAdminUser(currentUser)) {
      return true;
    }
    return false;
  }, [currentUser])

  return (
    <>
      <Layout fullWidth={true} hideFooter={true}>
        <RibbonContainer>
          <RibbonContentContainer>
            <GoBackButton />
            <HeadlineMedium>Office management</HeadlineMedium>
          </RibbonContentContainer>
        </RibbonContainer>

        <ContentContainer>
          <HeaderRow style={{marginBottom: 24}}>
            <HeadlineMedium>Office information</HeadlineMedium>
          </HeaderRow>
          <FlatContentCard style={{marginBottom: 24}}>
            <BodyRegular weight={600}>How it works</BodyRegular>
            <BodyRegular>Offices appear for users to book in Team Whereabouts. You can assign users to an office so that this will be there default location.</BodyRegular>
          </FlatContentCard>
          {orderedOffice.map((office: OfficeEntity, key: number) => (
            <OfficeContentCard office={office} key={key} />
          ))}
          <PrimaryButton style={{marginTop: 24}}
                         link={'/manage/offices/add'}
                         disabled={!canAddOffices}
                         text={'whereabouts.add-office-button'} />
        </ContentContainer>
      </Layout>
    </>
  )
}

interface Props {
}


const ContentContainer = styled.div`
  max-width: 1400px;
  background-color: white;
  padding: 48px 64px;
  margin: 24px auto 0 auto;

  @media (${tablet}) {
     padding: 48px 64px;
     border-radius: 24px;
   }
`

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

const RibbonContainer = styled.div`
  background-color: white;
  box-shadow: 0 9px 22px 0 rgba(46, 74, 148, 0.08);
`

const RibbonContentContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1400px;
  padding: 16px 0;
`
